import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Initialize language from localStorage if available; fall back to 'jp'
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
      return 'jp';
    }
    try {
      const storedLanguage = window.localStorage.getItem('language');
      return storedLanguage || 'jp';
    } catch {
      return 'jp';
    }
  });

  const changeLanguage = (lang) => {
    localStorage.setItem('language', lang);
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}